import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import {
  StartMedicareMigrationReqProps,
  StartMedicareMigrationResProps
} from './medicareMigration.types';

export const medicareMigrationApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    startMedicareMigration: build.mutation<
      StartMedicareMigrationResProps,
      StartMedicareMigrationReqProps
    >({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/medicare-migration/start'
      })
    })
  }),
  reducerPath: 'medicareMigrationApi'
});

export const { useStartMedicareMigrationMutation } = medicareMigrationApi;
